import { 
  DeleteOutlined, 
  EditOutlined, 
  IdcardOutlined, 
  MedicineBoxOutlined, 
  UnorderedListOutlined,
  RocketOutlined 
} from "@ant-design/icons";
import { Button, Avatar, Switch, Select, Tag  } from "antd"; // Importez Switch ici

const getInitials = (firstName, lastName) => {
    const firstInitial = firstName ? firstName.charAt(0) : "";
    const lastInitial = lastName ? lastName.charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
};

// On ajoute 'handleToggleDashboardStats' comme 4ème argument
export const columns = (openAssignModal, naviagteTo, showDeleteModal, handleToggleDashboardStats, handleCategoryChange) => [
    {
      title: "Avatar",
      dataIndex: "avatar",
      key: "avatar",
      width: 70,
      render: (_, record) => (
        <Avatar size={32} style={{ backgroundColor: "#214177", verticalAlign: "middle", fontSize: '12px' }}>
          {getInitials(record.firstname, record.lastname)}
        </Avatar>
      ),
    },
    { 
        title: "Nom", 
        dataIndex: "lastname", 
        key: "lastName", 
        render: t => <span style={{ fontWeight: '600' }}>{t ? t.toUpperCase() : ''}</span> 
    },
    { title: "Prénom", dataIndex: "firstname", key: "firstName" },
    { title: "Adresse", dataIndex: "address", key: "address", ellipsis: true },
    { title: "Téléphone", dataIndex: "phoneNumber", key: "phone" },

    {
      title: "Gamme / Catégorie",
      dataIndex: "category",
      key: "category",
      width: 160,
      render: (category, record) => (
        <Select
          size="small"
          placeholder="Choisir gamme"
          value={category || undefined}
          onChange={(val) => handleCategoryChange(record, val)}
          style={{ width: 140 }}
          allowClear
        >
          <Select.Option value="AKTIV">
            <Tag color="blue" style={{ margin: 0, fontWeight: 'bold' }}>AKTIV</Tag>
          </Select.Option>
          <Select.Option value="SANOSAN">
            <Tag color="green" style={{ margin: 0, fontWeight: 'bold' }}>SANOSAN</Tag>
          </Select.Option>
          <Select.Option value="MATERNITE">
            <Tag color="purple" style={{ margin: 0, fontWeight: 'bold' }}>MATERNITE</Tag>
          </Select.Option>
        </Select>
      ),
    },

    // --- COLONNE MODIFIÉE : MAINTENANT UN SWITCH INTERACTIF ---
    {
      title: "Dashboard",
      dataIndex: "excludeFromStats",
      key: "stats",
      width: 120,
      render: (exclu, record) => (
        <Switch 
            size="small"
            checked={!exclu} // Si exclu est false (0), le switch est bleu (Actif)
            onChange={() => handleToggleDashboardStats(record)} 
            checkedChildren="Inclus"
            unCheckedChildren="Exclu"
        />
      ),
    },

    {
      title: "Action",
      key: "action",
      width: 650,
      render: (record) => (
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <Button type="link" size="small" style={{ fontSize: '14px', padding: '0 5px' }} onClick={() => openAssignModal(record, 'products')}>
               <IdcardOutlined /> Produits
            </Button>
            
            <Button type="link" size="small" style={{ fontSize: '14px', padding: '0 5px' }} onClick={() => openAssignModal(record, 'samples')}>
               <MedicineBoxOutlined /> Échantillons
            </Button>

            <Button type="link" size="small" style={{ fontSize: '14px', padding: '0 5px', color: '#722ed1' }} onClick={() => openAssignModal(record, 'specific')}>
              <RocketOutlined /> Spécifiques
            </Button>
            
            <Button type="link" size="small" style={{ fontSize: '14px', padding: '0 5px' }} onClick={() => naviagteTo(`assigné/délégué/${record.id}`)}>
               <UnorderedListOutlined /> Assignations
            </Button>

            <Button className="btn-details" size="small" style={{ fontSize: '14px', height: '35px', padding: '0 10px', marginLeft: '5px' }} onClick={() => naviagteTo(`edit/délégué/${record.id}`)} icon={<EditOutlined />}>
                Modifier
            </Button>

            <Button type="text" danger size="small" onClick={() => showDeleteModal(record.id)} icon={<DeleteOutlined />} />
        </div>
      ),
    },
];